import React, { useContext } from 'react'
import { ModalContext } from 'providers/Modal'
import Sticky from 'components/Sticky'
import 'styles/registerFree.scss'
import { trackButtonClick } from 'tracking/homepage'

const RegisterFree = props => {
  const { setActive } = useContext(ModalContext)

  const handleClick = () => {
    setActive('register')
    trackButtonClick({
      fieldValue: `Register for Free`,
    })
  }

  const wrapClass =
    props.revampBucket === 'C' ? 'revisedRegisterFreeWrap' : 'registerFreeWrap'

  const ctaClass =
    props.revampBucket === 'C' ? 'revisedRegisterFree' : 'registerFree'

  return (
    <Sticky className={'registerFreeFixWrap'}>
      <div className={wrapClass}>
        <button
          data-testid="register_for_free"
          type="button"
          onClick={handleClick}
          className={`btn btn-primary btn-md btn-block ${ctaClass}`}
        >
          Register for Free
          {props.revampBucket === 'C' && <span className="registerFreeArrow" />}
        </button>
        {props.revampBucket === 'C' && (
          <div className="viewMatches">To View Your Matches</div>
        )}
      </div>
    </Sticky>
  )
}

export default RegisterFree
